var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.017 5.58244C13.4252 5.30537 13.4252 4.69465 13.017 4.41757L6.69388 0.125532C6.237 -0.184594 5.62503 0.14888 5.62503 0.707967L5.62503 3.60001L0.812528 3.6C0.432834 3.6 0.125028 3.91341 0.125028 4.3L0.125028 5.7C0.125028 6.0866 0.432833 6.40001 0.812528 6.40001L5.62503 6.40001L5.62503 9.29204C5.62503 9.85113 6.237 10.1846 6.69388 9.87448L13.017 5.58244Z","fill":"#CBD5E1"}));
}

ArrowRight.defaultProps = {"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
